import { Link } from 'wouter'

/** Floating UI overlay on the map screen. */
export function Hud() {
  return (
    <>
      <header className="pointer-events-none absolute inset-x-0 top-0 z-20 flex items-start justify-between gap-4 p-5">
        <div className="pointer-events-auto">
          <h1 className="drop-shadow-[0_2px_12px_rgba(0,0,0,0.8)]">
            <img
              src="/logo.png"
              alt="System 404: Signal Lost"
              width={1699}
              height={624}
              className="w-56"
            />
          </h1>
          <p className="mt-1 max-w-xs text-xs text-slate-400">
            An interactive map of a solar system nobody comes back from.
          </p>
        </div>

        <nav className="pointer-events-auto flex items-center gap-2">
          <Link
            href="/lorebook"
            className="rounded-full border border-edge bg-panel px-4 py-2 text-sm text-slate-200 backdrop-blur transition hover:border-signal/60 hover:text-white"
          >
            Lorebook
          </Link>
          <Link
            href="/characters"
            className="rounded-full border border-edge bg-panel px-4 py-2 text-sm text-slate-200 backdrop-blur transition hover:border-signal/60 hover:text-white"
          >
            Characters
          </Link>
          <Link
            href="/export"
            className="rounded-full border border-edge bg-panel px-4 py-2 text-sm text-slate-200 backdrop-blur transition hover:border-signal/60 hover:text-white"
          >
            Export
          </Link>
        </nav>
      </header>

      <footer className="pointer-events-none absolute inset-x-0 bottom-0 z-20 flex justify-center p-4">
        <div className="pointer-events-auto hidden rounded-full border border-edge bg-panel px-4 py-1.5 text-[11px] text-slate-400 backdrop-blur sm:block">
          <span className="text-slate-500">scroll</span>/<span className="text-slate-500">pinch</span> zoom ·{' '}
          <span className="text-slate-500">drag</span> pan ·{' '}
          <span className="text-slate-500">click</span> a body ·{' '}
          <span className="text-slate-500">arrows</span> cycle ·{' '}
          <span className="text-slate-500">esc</span> close
        </div>
      </footer>
    </>
  )
}
